import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative w-full min-h-[520px] md:min-h-[600px] flex items-end">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20entertainment%20newsroom%20with%20dramatic%20warm%20lighting%20red%20and%20gold%20accents%20abstract%20geometric%20shapes%20floating%20dynamic%20composition%20editorial%20energy%20cinematic%20atmosphere%20bold%20typography%20vibe&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="51吃瓜 - 娱乐资讯门户"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/80"></div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 pb-12 md:pb-16">
          <div className="max-w-6xl mx-auto">
            <div className="mb-6">
              <span className="inline-block bg-accent-500 text-background-50 text-xs font-bold px-3 py-1 rounded-full mb-4">
                官方入口 · 永不迷路
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
                51吃瓜域名
                <span className="block text-accent-300 text-xl md:text-3xl lg:text-4xl mt-2">
                  最新地址导航 · 防失联入口
                </span>
              </h1>
              <p className="text-base md:text-lg text-background-200/90 max-w-2xl leading-relaxed">
                本站为51吃瓜官方入口地址导航页，汇总最新域名、备用地址及防失联跳转方案。收藏本页，随时找到可用的51吃瓜域名，吃瓜不迷路。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
              {featuredArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group relative rounded-xl overflow-hidden bg-background-50/10 backdrop-blur-sm border border-background-50/20 hover:border-primary-400/50 transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <span className="inline-block text-xs text-primary-300 bg-primary-500/20 px-2 py-0.5 rounded-full mb-2">
                      {article.categoryName}
                    </span>
                    <h3 className="text-sm md:text-base font-bold text-background-50 line-clamp-2 group-hover:text-accent-300 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-background-300/70 mt-2 line-clamp-2 hidden md:block">{article.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}